import { clone } from 'lodash'
import { createSpaIconURL, createSpaLink } from './links'

const getCanopySpas = data => {
  let envType = 'sbx'

  if (['prd', 'production'].includes(process.env.REACT_APP_APP_ENV)) {
    envType = 'prd'
  }

  const result = Object.keys(data).reduce((acc, spaKey) => {
    const spa = data[spaKey]

    if (spa.canopy !== undefined) {
      const shape = clone(spa.canopy)
      shape.icon = createSpaIconURL(envType, spa.type)
      shape.link = createSpaLink(spa)
      acc.push(shape)
    }

    return acc
  }, [])

  return result
}

export default getCanopySpas
